import { FC, ReactNode } from "react";
import cx from "classnames";
import { ChevronIcon, CloseIcon } from "@/components/Icon";
import Typography from "@/components/Typography";
import { IconButton } from "@/components/Button";
import styles from "./MobilePaperTitle.module.scss";

type Props = {
  title: string | ReactNode;
  onGoBack: () => void;
  iconType?: "back" | "close";
  titleClassName?: string;
};

const MobilePaperTitle: FC<Props> = ({
  title,
  onGoBack,
  iconType = "back",
  children,
  titleClassName,
}) => {
  return (
    <div className={styles.container}>
      <div className={cx(styles.titleContainer, titleClassName)}>
        <IconButton onClick={onGoBack} className={styles.button}>
          {iconType === "back" ? <ChevronIcon dir="left" /> : <CloseIcon />}
        </IconButton>

        {typeof title === "string" ? (
          <Typography variant="h6" className={styles.title}>
            {title}
          </Typography>
        ) : (
          title
        )}
      </div>
      {children}
    </div>
  );
};

export default MobilePaperTitle;
